$shm_hitalama_map_widget_any $mol_ghost
	Sub_hack* $shm_hitalama_map_widget_float
	Sub $shm_hitalama_map_widget_float
		widget <= widget $shm_hitalama_map_widget
		Map_page <= Map_page $shm_hitalama_map_page
	custom_expose null
	setup_obj* null
	widgets *
		iframe <= Iframe $shm_hitalama_map_widget_float_iframe
		text <= Text $shm_hitalama_map_widget_float_text
		image <= Image $shm_hitalama_map_widget_float_image
		drawing <= Drawing $shm_hitalama_map_widget_float_drawing
		rect <= Rect $shm_hitalama_map_widget_float_rect
		circle <= Circle $shm_hitalama_map_widget_float_circle
		text_md <= Text_md $shm_hitalama_map_widget_float_text_md
		form <= Form $shm_hitalama_map_widget_float_form
		table <= Table $shm_hitalama_map_widget_float_table
		tabulator <= Tabulator $shm_hitalama_map_widget_float_tabulator
		code <= Code $shm_hitalama_map_widget_float_code
		component <= Component $shm_hitalama_map_widget_float_component
		component_view <= Component_view $shm_hitalama_map_widget_float_component_view
		component_parser <= Component_parser $shm_hitalama_map_widget_float_component_parser
		chart <= Chart $shm_hitalama_map_widget_float_chart
		echarts <= Echarts $shm_hitalama_map_widget_float_echarts
		chart_filter <= Chart_filter $shm_hitalama_map_widget_float_chart_filter
		customdom <= Customdom $shm_hitalama_map_widget_float_customdom
		file <= File $shm_hitalama_map_widget_float_file
		table_novirt <= Table_novirt $shm_hitalama_map_widget_float_table_novirt
		form_edit <= Form_edit $shm_hitalama_map_widget_float_form_edit
		code_css <= Code_css $shm_hitalama_map_widget_float_code_css
		code_html <= Code_html $shm_hitalama_map_widget_float_code_html
		customizer <= Customizer $shm_hitalama_map_widget_float_customizer
		form_custom <= Form_custom $shm_hitalama_map_widget_float_form_custom
		code_sql <= Code_sql $shm_hitalama_map_widget_float_code_sql
		code_js <= Code_js $shm_hitalama_map_widget_float_code_js
		method <= Method $shm_hitalama_map_widget_float_method
		code_ts <= Code_ts $shm_hitalama_map_widget_float_code_ts
		layout_vert <= Layout_vert $shm_hitalama_map_widget_float_layout_vert
		layout_hor <= Layout_hor $shm_hitalama_map_widget_float_layout_hor
		custom <= Custom $shm_hitalama_map_widget_float
		chrome_telegram <= Chrome_telegram $shm_hitalama_map_widget_float_chrome_telegram
		viewport_frame <= Viewport_frame $shm_hitalama_map_widget_float_viewport_frame
		tokens <= Tokens $shm_hitalama_map_widget_float_tokens
		posts <= Posts $shm_hitalama_map_widget_float_posts
		prompt <= Prompt $shm_hitalama_map_widget_float_prompt
		ai_request <= Ai_request $shm_hitalama_map_widget_float_ai_request
		opencode_session <= Opencode_session $shm_hitalama_map_widget_float_opencode_session
		notebook <= Notebook $shm_hitalama_map_widget_float_notebook
		notebook2 <= Notebook2 $shm_hitalama_map_widget_float_notebook2
		notebook_edit <= Notebook_edit $shm_hitalama_map_widget_float_notebook_edit
		notebook_preview <= Notebook_preview $shm_hitalama_map_widget_float_notebook_preview
		group <= Group $shm_hitalama_map_widget_float_group
		settings <= Settings $shm_hitalama_map_widget_float_settings
		settings_chart <= Settings_chart $shm_hitalama_map_widget_float_settings_chart
		settings_echarts <= Settings_echarts $shm_hitalama_map_widget_float_settings_echarts
		settings_tabulator <= Settings_tabulator $shm_hitalama_map_widget_float_settings_tabulator
		settings_table <= Settings_table $shm_hitalama_map_widget_float_settings_table
		- settings_iframe <= Settings_iframe $shm_hitalama_map_widget_float_settings_iframe
		settings_posts <= Settings_posts $shm_hitalama_map_widget_float_settings_posts
		settings_customdom <= Settings_customdom $shm_hitalama_map_widget_float_settings_customdom
		settings_text_md <= Settings_text_md $shm_hitalama_map_widget_float_settings_text_md
		settings_widget_page <= Settings_widget_page $shm_hitalama_map_widget_float_settings_widget_page
		autoview <= Autoview $shm_hitalama_map_widget_float_autoview
